if (!customElements.get('upper-compre-junto')) {
  customElements.define('upper-compre-junto', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick, { signal: this.abort.signal });
      this.initGalleries(this);
      this.querySelectorAll('[data-ucj-card]').forEach(card => {
        const track = card.querySelector('[data-ucj-images]');
        if (!track || track.children.length < 2) return;
        card.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && window.matchMedia('(hover:hover)').matches) track.scrollTo({left:track.clientWidth, behavior:'instant'});
        }, {signal:this.abort.signal});
        card.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') track.scrollTo({left:0, behavior:'instant'});
        }, {signal:this.abort.signal});
      });
    }
    disconnectedCallback() {
      this.closePreview();
      this.abort?.abort();
      this.ready = false;
    }
    initGalleries(root) {
      root.querySelectorAll('[data-ucj-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-ucj-images]');
        const count = gallery.querySelector('[data-ucj-counter]');
        track.addEventListener('scroll', () => {
          if (count) count.textContent = `${Math.round(track.scrollLeft / Math.max(track.clientWidth,1)) + 1} / ${track.children.length}`;
        }, {passive:true,signal:this.abort.signal});
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            event.stopPropagation();
            track.scrollBy({left:track.clientWidth * (event.key === 'ArrowRight' ? 1 : -1),behavior:this.motion()});
          }
        }, {signal:this.abort.signal});
        let start = null;
        track.addEventListener('pointerdown', event => {
          start={x:event.clientX,y:event.clientY,scroll:track.scrollLeft};
          if(event.pointerType==='mouse' && event.button===0)event.preventDefault();
        }, {signal:this.abort.signal});
        track.addEventListener('pointermove',event=>{
          if(start && event.pointerType==='mouse' && (event.buttons&1) && Math.abs(start.x-event.clientX)>8){track.setPointerCapture(event.pointerId);track.scrollLeft=start.scroll+start.x-event.clientX;}
        },{signal:this.abort.signal});
        track.addEventListener('dragstart',event=>event.preventDefault(),{signal:this.abort.signal});
        track.addEventListener('click', event => {
          if (start && (Math.abs(event.clientX-start.x)>8 || Math.abs(event.clientY-start.y)>8)) {event.preventDefault();event.stopPropagation();}
          start=null;
        }, {capture:true,signal:this.abort.signal});
      });
    }
    motion() { return window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'; }
    handleClick(event) {
      const photo = event.target.closest('[data-ucj-photo]');
      if (photo) {
        const track=photo.closest('[data-ucj-gallery]').querySelector('[data-ucj-images]');
        const index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
        const next=(index+Number(photo.dataset.ucjPhoto)+track.children.length)%track.children.length;
        track.scrollTo({left:next*track.clientWidth,behavior:this.motion()});
        return;
      }
      if (event.target.closest('[data-ucj-next]')) {
        const track=this.querySelector('[data-ucj-products]');
        if (track.scrollWidth>track.clientWidth+1) {
          track.scrollTo({left:track.scrollLeft>=track.scrollWidth-track.clientWidth-2?0:track.scrollLeft+track.clientWidth*.7,behavior:this.motion()});
        } else {
          this.querySelector('[data-ucj-open]')?.focus();
        }
        return;
      }
      const opener=event.target.closest('[data-ucj-open]');
      if (opener) this.openPreview(opener);
      if (event.target.closest('[data-ucj-close]')) this.closePreview();
      const choice=event.target.closest('[data-ucj-value]');
      if (choice && !choice.disabled) {
        const group=choice.closest('[data-ucj-option]');
        this.selected[Number(group.dataset.ucjOption)]=choice.dataset.ucjValue;
        for (let i=Number(group.dataset.ucjOption)+1;i<this.selected.length;i++) {
          if (!this.data.variants.some(v=>v.available && v.options.every((value,index)=>index>i || !this.selected[index] || value===this.selected[index]))) this.selected[i]=null;
        }
        this.updateVariant();
      }
      if (event.target.closest('[data-ucj-add]')) this.addToCart();
    }
    openPreview(opener) {
      if (this.busy) return;
      this.closePreview();
      document.querySelectorAll('dialog.ucj-modal[open]').forEach(dialog=>dialog.close());
      this.opener=opener;
      const template=opener.closest('[data-ucj-card]').querySelector('[data-ucj-preview]');
      this.dialog=document.createElement('dialog');
      this.dialog.className='ucj-modal';
      this.dialog.append(template.content.cloneNode(true));
      this.dialog.setAttribute('aria-labelledby',this.dialog.querySelector('h2').id);
      this.append(this.dialog);
      this.data=JSON.parse(this.dialog.querySelector('[data-ucj-data]').textContent);
      this.selected=this.data.single ? [...this.data.variants[0].options] : Array(this.dialog.querySelectorAll('[data-ucj-option]').length).fill(null);
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.closePreview();});
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.closePreview();}});
      this.previousOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      this.initGalleries(this.dialog);
      this.updateVariant();
      this.dialog.showModal();
      this.dialog.querySelector('[data-ucj-close]').focus();
    }
    closePreview() {
      if (!this.dialog) return;
      this.dialog.close();
      this.dialog.remove();
      this.dialog=null;
      document.body.style.overflow=this.previousOverflow||'';
      this.opener?.focus({preventScroll:true});
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang||'pt-BR',{style:'currency',currency:this.dataset.currency||'BRL'}).format(cents/100);
    }
    updateVariant() {
      const dialog=this.dialog;
      if (!dialog) return;
      dialog.querySelectorAll('[data-ucj-option]').forEach(group=>{
        const index=Number(group.dataset.ucjOption);
        group.querySelector('[data-ucj-selected]').textContent=this.selected[index]||'selecione';
        group.querySelectorAll('[data-ucj-value]').forEach(button=>{
          button.setAttribute('aria-pressed',String(this.selected[index]===button.dataset.ucjValue));
          button.disabled=!this.data.variants.some(variant=>variant.available && variant.options[index]===button.dataset.ucjValue && variant.options.every((value,i)=>i>=index||!this.selected[i]||this.selected[i]===value));
        });
      });
      this.variant=this.data.variants.find(variant=>variant.options.every((value,index)=>value===this.selected[index]));
      const button=dialog.querySelector('[data-ucj-add]');
      const chosen=this.variant;
      button.disabled=this.busy||!chosen?.available;
      button.textContent=this.busy?'Adicionando…':!this.data.available?'Esgotado':chosen?chosen.available?'Adicionar ao carrinho':'Esgotado':'Selecione as opções';
      dialog.querySelector('[data-ucj-status]').textContent=chosen && !chosen.available?'Esta combinação está esgotada. Escolha outra opção.':'';
      if (chosen) {
        dialog.querySelector('[data-ucj-price]').textContent=this.money(chosen.price);
        const compare=dialog.querySelector('[data-ucj-compare]');
        compare.hidden=chosen.compare<=chosen.price;
        compare.textContent=this.money(chosen.compare);
        const details=dialog.querySelector('[data-ucj-details]');
        const url=new URL(details.href);
        url.searchParams.set('variant',chosen.id);
        details.href=url.href;
        if(this.lastVariant!==chosen.id){const gallery=dialog.querySelector('[data-ucj-images]');gallery.scrollTo({left:Math.min(chosen.image,gallery.children.length-1)*gallery.clientWidth,behavior:'instant'});this.lastVariant=chosen.id;}
      }
    }
    async addToCart() {
      if(this.busy||!this.variant?.available||!this.dialog)return;
      this.busy=true;
      this.updateVariant();
      const dialog=this.dialog;
      const root=window.Shopify?.routes?.root||'/';
      const drawer=document.querySelector('cart-drawer');
      const sections=drawer?.getSectionsToRender?.()||[];
      const body={items:[{id:this.variant.id,quantity:1}]};
      if(sections.length){body.sections=[...new Set(sections.map(s=>s.section))];body.sections_url=window.location.pathname;}
      let added=false;
      try {
        const response=await fetch(`${root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const result=await response.json();
        if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'Não foi possível adicionar este item. Tente novamente.');
        added=true;
        this.closePreview();
        const rendered=sections.length && sections.every(s=>result.sections?.[s.section]);
        if(drawer?.renderContents&&rendered){drawer.setActiveElement?.(this.opener);drawer.renderContents(result);}
        else window.location.assign(this.dataset.cartUrl||`${root}cart`);
      }catch(error){
        if(added){window.location.assign(this.dataset.cartUrl||`${root}cart`);return;}
        if(this.dialog===dialog){this.busy=false;this.updateVariant();dialog.querySelector('[data-ucj-status]').textContent=error.message||'Não foi possível adicionar este item. Tente novamente.';}
      }finally{this.busy=false;}
    }
  });
}
